declare let Pikaday: any;

import './_pikaday.js';

export class PikadayComponent {
    init(options: any = null): any {
        return new Pikaday(options);
    }
}
